import * as React from "react";
import { useWindowDimensions } from "react-native";
import { createDrawerNavigator } from "@react-navigation/drawer";
import { drawerItemsMain } from "./ChinaTrackerDrawerItemsMain ";
import CustomDrawerContent from "../../../components/custom/CustomDrawerContent";
import ChinaTrackerScreen from "../../../screens/ChinaTracker/ChinaTrackerScreen";
import ChinaTrackerDetailsReport from "../../../screens/ChinaTracker/partials/ChinaTrackerDetailsReport";
import { useTranslation } from "../../../utils/useTranslation";
import ChinaShipmentScreen from "../../../screens/ChinaShipment/ChinaShipmentScreen";
import ChinaShipmentDetailsReport from "../../../screens/ChinaShipment/partials/ChinaShipmentDetailsReport";
import ChinaGlobalShipment from "../../../screens/ChinaShipment/ChinaGlobalShipment";
import GlobalShipmentDetailsReport from "../../../screens/ChinaShipment/global/GlobalShipmentDetailsReport";

const Drawer = createDrawerNavigator();

export default function ChinaTrackerDrawerNavigator() {
  const dimensions = useWindowDimensions();
  const { t } = useTranslation();

  const translatedItems = drawerItemsMain
    .filter((item: any) => {
      if (item.key === "GlobalShipment") {
        return process.env.NODE_ENV !== "production";
      }
      return true;
    })
    .map((item: any) => {
      let translatedTitle = item.title;
      let translatedRoutes = [...item.routes];

      if (item.key === "ChinaTracker") {
        translatedTitle = t("chinaOrderTracker");
        translatedRoutes[0].title = t("chinaOrderTracker");
      } else if (item.key === "ChinaShipment") {
        translatedTitle = t("chinaShipment");
        translatedRoutes[0].title = t("chinaShipment");
      } else if (item.key === "GlobalShipment") {
        translatedTitle = t("globalShipment");
        translatedRoutes[0].title = t("globalShipment");
      }

      return {
        ...item,
        title: translatedTitle,
        routes: translatedRoutes,
      };
    });
  return (
    <Drawer.Navigator
      screenOptions={{
        drawerStyle: {
          width: 200,
        },
        drawerLabelStyle: {
          fontSize: 12,
          textTransform: "none",
        },
        drawerType: dimensions.width >= 768 ? "front" : "front", //'permanent' : 'front',
      }}
      drawerContent={(props) => (
        <CustomDrawerContent drawerItems={translatedItems} {...props} />
      )}
    >
      <Drawer.Screen
        options={{
          drawerLabel: "ChinaTracker",
          title: t("chinaOrderTracker"),
        }}
        name="ChinaTrackerReport"
        component={ChinaTrackerScreen}
      />

      <Drawer.Screen
        options={{
          drawerLabel: "ChinaTrackerDetailsReport",
          title: t("chinaOrderTracker"),
        }}
        name="ChinaTrackerDetailsReport"
        component={ChinaTrackerDetailsReport}
      />

      <Drawer.Screen
        options={{
          drawerLabel: "ChinaShipment",
          title: t("chinaShipment"),
        }}
        name="ChinaShipmentReport"
        component={ChinaShipmentScreen}
      />

      {process.env.NODE_ENV !== "production" && (
        <Drawer.Screen
          options={{
            drawerLabel: "GlobalShipment",
            title: t("globalShipment"),
          }}
          name="GlobalShipmentReport"
          component={ChinaGlobalShipment}
        />
      )}

      <Drawer.Screen
        options={{
          drawerLabel: "ChinaShipmentDetailsReport",
          title: t("chinaShipmentDetailsReport"),
        }}
        name="ChinaShipmentDetailsReport"
        component={ChinaShipmentDetailsReport}
      />

      <Drawer.Screen
        options={{
          drawerLabel: "GlobalShipmentDetailsReport",
          title: t("globalShipmentDetailsReport"),
        }}
        name="GlobalShipmentDetailsReport"
        component={GlobalShipmentDetailsReport}
      />
    </Drawer.Navigator>
  );
}
